import { render, staticRenderFns } from "./FlatCard.vue?vue&type=template&id=99043738&"
import script from "./FlatCard.vue?vue&type=script&lang=js&"
export * from "./FlatCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports